import { render, staticRenderFns } from "./Masklayer.vue?vue&type=template&id=c131aa02&scoped=true"
import script from "./Masklayer.vue?vue&type=script&lang=js"
export * from "./Masklayer.vue?vue&type=script&lang=js"
import style0 from "./Masklayer.vue?vue&type=style&index=0&id=c131aa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c131aa02",
  null
  
)

export default component.exports